/*
 * The "reward mountain": a horizontal bar that slowly fills with stars as
 * the child completes missions. Crossing the threshold = reward unlocked.
 *
 * Inspired by the cumulative-stars mechanic in Kids Happy Timer.
 */
export default function RewardMountain({ total = 0, goal = 50, compact = false }) {
  const safeGoal = Math.max(1, goal);
  const ratio = Math.min(1, total / safeGoal);
  const remaining = Math.max(0, safeGoal - total);
  const reached = total >= safeGoal;

  return (
    <div
      className="rounded-3xl bg-gradient-to-br from-[#fdf3e8] to-[#ffe6d6] px-4 py-3 shadow-sm"
      style={{ position: "relative" }}
    >
      <div className="mb-1 flex items-center justify-between text-xs font-semibold uppercase tracking-wide text-[#7a6b8a]">
        <span>🏔️ Montagne de récompense</span>
        <span className="text-[#3b2a4a]">
          {total} <span className="text-[#7a6b8a]">/ {safeGoal} ⭐</span>
        </span>
      </div>

      <div
        className="relative h-3 w-full overflow-hidden rounded-full bg-white/70"
        aria-label={`Progression : ${total} étoiles sur ${safeGoal}`}
      >
        <div
          className="h-full rounded-full transition-all duration-700"
          style={{
            width: `${ratio * 100}%`,
            background: reached
              ? "linear-gradient(90deg, #f6c463, #ff8a65, #ff7043)"
              : "linear-gradient(90deg, #ffd29a, #ff8a65)",
          }}
        />
        <div
          aria-hidden
          className="absolute top-1/2 -translate-y-1/2 text-xs"
          style={{
            left: `calc(${ratio * 100}% - 8px)`,
            transition: "left 0.7s",
          }}
        >
          🦊
        </div>
      </div>

      {!compact && (
        <p className="mt-2 text-xs text-[#5b4b6b]">
          {reached
            ? "✨ Récompense débloquée — bravo !"
            : `Plus que ${remaining} étoile${remaining > 1 ? "s" : ""} avant la récompense.`}
        </p>
      )}
    </div>
  );
}
